import { createApp } from "vue";
import App from "./App.vue";
import { createI18n } from "vue-i18n";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import router from "../router/router.js";
import axios from "axios";
import FlagIcon from "vue-flag-icon";
import PrimeVue from 'primevue/config';
import "primevue/resources/themes/aura-light-green/theme.css";
// import "primevue/resources/primevue.min.css"; /* Deprecated */
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';
import 'primeicons/primeicons.css'

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}
let lang = "en";
if (localStorage.getItem("lang")) {
  lang = localStorage.getItem("lang");
}

const i18n = createI18n({
  locale: lang, // set locale
  // allowComposition: true, // you need to specify that!
  fallbackLocale: lang, // set fallback locale
  messages: loadLocaleMessages(), // set locale messages
});


const newLocal = lang;
axios.defaults.headers.common["Accept-Language"] = newLocal;
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api';
// axios.defaults.baseURL = 'https://admin.elsaygh.com/api';
axios.defaults.baseURL = "https://halim.learnoapp.net/api";


const app = createApp(App);
app.config.globalProperties.$websiteUrl = "https://elsaygh.com/";
app.config.globalProperties.axios = axios;
app.use(FlagIcon);
app.use(i18n);
app.use(router);
app.use(PrimeVue);

app.mount("#app");
